import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';

function CreatBrigade() {
  const [brigadeData, setBrigadeData] = useState({
    name: '',
    libelle: '',
    historique: '',
    observation: '',
    reference: '',
    implantation: '',
    filename: '',
    chefDeBrigade: '',
  });
  const [personnelSuggestions, setPersonnelSuggestions] = useState([]);
  const [selectedPersonnel, setSelectedPersonnel] = useState(null);

  // Fetch personnel suggestions based on input
  const handleChefDeBrigadeChange = async (e) => {
    const query = e.target.value;
    setBrigadeData((prevData) => ({
      ...prevData,
      chefDeBrigade: query,
    }));

    if (query.length > 2) {
      // Commencer la recherche après 2 caractères
      try {
        const res = await axios.get(`personnel?nomprenom=${query}`);
        setPersonnelSuggestions(res.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions de personnels', error);
      }
    } else {
      setPersonnelSuggestions([]);
    }
  };

  // Handle personnel selection
  const handlePersonnelSelect = (personnel) => {
    setBrigadeData((prevData) => ({
      ...prevData,
      chefDeBrigade: personnel.nomprenom,
    }));
    setSelectedPersonnel(personnel);
    setPersonnelSuggestions([]);
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBrigadeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const brigadePayload = {
      ...brigadeData,
      chefDeBrigadeId: selectedPersonnel ? selectedPersonnel.id : null,
    };

    try {
      await axios.post('/brigade/', brigadePayload);
      alert('Brigade créée avec succès');
      // Réinitialiser le formulaire après la soumission
      setBrigadeData({
        name: '',
        libelle: '',
        historique: '',
        observation: '',
        reference: '',
        implantation: '',
        chefDeBrigade: '',
      });
      setSelectedPersonnel(null);
    } catch (error) {
      console.error('Erreur lors de la création de la brigade', error);
    }
  };

  return (
    <div className="container pt-5 mt-3">
      <h1>Créer une Nouvelle Brigade</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nom de la Brigade</label>
          <input type="text" name="name" value={brigadeData.name} onChange={handleInputChange} required className="form-control" />
        </div>
        <div>
          <label>Libellé</label>
          <input type="text" name="libelle" value={brigadeData.libelle} onChange={handleInputChange} className="form-control" />
        </div>
        <div>
          <label>Historique</label>
          <textarea name="historique" value={brigadeData.historique} onChange={handleInputChange} className="form-control" />
        </div>
        <div>
          <label>Observation</label>
          <textarea name="observation" value={brigadeData.observation} onChange={handleInputChange} className="form-control" />
        </div>
        <div>
          <label>Référence</label>
          <input type="text" name="reference" value={brigadeData.reference} onChange={handleInputChange} className="form-control" />
        </div>
        <div>
          <label>Implantation</label>
          <input type="text" name="implantation" value={brigadeData.implantation} onChange={handleInputChange} className="form-control" />
        </div>
        <div>
          <label>Chef de Brigade</label>
          <input type="text" name="chefDeBrigade" value={brigadeData.chefDeBrigade} onChange={handleChefDeBrigadeChange} placeholder="Entrez le nom du chef de brigade" className="form-control" />
          {personnelSuggestions.length > 0 && (
            <ul>
              {personnelSuggestions.map((personnel) => (
                <li key={personnel.id} onClick={() => handlePersonnelSelect(personnel)} style={{ cursor: 'pointer' }}>
                  {personnel.nomprenom}
                </li>
              ))}
            </ul>
          )}
        </div>
        <button className="btn btn-primary" type="submit">
          Créer Brigade
        </button>
      </form>
    </div>
  );
}

export default CreatBrigade;
